import * as React from "react";
import FormWarningsProvider from "contexts/FormWarningsProvider";
import AnomalyEventForm from "./AnomalyEventForm";
const AnomalyEventFormContainer = ({ eventDefinition, onChange, validation }) => /* @__PURE__ */ React.createElement(FormWarningsProvider, null, /* @__PURE__ */ React.createElement(AnomalyEventForm, { eventDefinition, onChange, validation }));
export default AnomalyEventFormContainer;
